import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { IconButtonComponent } from '@libs/common/components';
import { VoucherListItem } from '@libs/shop/models';

@Component({
  selector: 'ui-order-voucher-item',
  imports: [
    IconButtonComponent,
  ],
  templateUrl: './order-voucher-item.component.html',
  styleUrl: './order-voucher-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderVoucherItemComponent {
  public voucher: InputSignal<VoucherListItem> = input.required();
  public deleting: InputSignal<boolean> = input.required();
  public deleteVoucher: OutputEmitterRef<string> = output();
}
